import styled from 'styled-components';

export const Timestamp = styled.span<{color: string}>`
  margin-left: 16px;
  margin-right: 2px;
  color: ${(p) => p.color};
`;
